exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel{max-width:300px;box-shadow:0 3px 10px rgba(0,0,0,0.15);position:absolute;top:0;z-index:1050;left:0}.panel.floater{transform:translateY(-50%)}.panel .panel-heading{background:none}.panel .panel-heading .panel-title{color:#265390;font-size:14px;float:left;font-weight:600;margin-top:3px}.panel .panel-heading .btn{padding:3px 7px;font-size:12px;line-height:1.5;border-radius:3px;min-width:60px}label{display:block;font-weight:400;font-size:14px;color:#999;margin:0}select.form-control{height:30px}.error-msg{color:#F44336}.radio{margin-bottom:15px}.btn-group{display:-ms-flexbox;display:flex;border:1px solid #ccc;border-radius:4px}.btn-group>.btn{-ms-flex:1;flex:1;border:none}.btn-group>.btn.active{background:#265390;color:#fff}.has-error{border-color:#F44336}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/new-rule/set-condition/set-condition.component.scss
// module id = 1097
// module chunks = 0 1 2 3 4 5 6 7